import { risapi, getAxiosConfig, getAPIFullUrl } from './risapi';

/**
 * Fetches the club's member balance sheet.
 * @param {object} filters - The request filters, e.g., { filter: 'negative_balance' }.
 * @param {function} callback - The function to call with the response.
 */
export const getBalanceSheet = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/balance-sheet', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};